export class ButtonOverlay {

  constructor({widget, showPause=true, showDatasource=false, showSettings=false}){

    this.buttonDiv = document.createElement("div");
    this.buttonDiv.style = "user-select: none;";

    this.fullscreenSpan = document.createElement("span");
    this.fullscreenSpan.innerHTML = "&#x26F6;";
    this.buttonDiv.appendChild(this.fullscreenSpan);
    this.fullscreenSpan.addEventListener('click', event => {
      widget.toggleFullscreen();
    });

    if(showPause){
      this.pauseSpan = document.createElement("span");
      this.pauseSpan.innerHTML = "&#x23EF;";
      this.pauseSpan.style = 'display: inline-block;transform:translateY(-3pt);';
      this.pauseSpan.addEventListener('click', event => {
          widget.togglePause();
      });
      this.addButton(this.pauseSpan);
    }

    if(showDatasource){
      this.datasourceSpan = document.createElement("span");
      this.datasourceSpan.innerHTML = "&#x26C3;";
      this.datasourceSpan.style = 'display: inline-block;transform:translateY(-3pt);direction:rtl;';
      this.addButton(this.datasourceSpan);
    }

    if(showSettings){
      this.settingsSpan = document.createElement("span");
      this.settingsSpan.innerHTML = "&#x2261;";
      this.settingsSpan.style = 'display: inline-block;transform:translateY(-2.1pt);direction:rtl;';
      this.addButton(this.settingsSpan);
    }

    this.buttonDiv.classList.add('button-overlay');
    widget.DOMElement.appendChild(this.buttonDiv);

  }

  addButton(button, index){
    if(index === undefined){
      this.buttonDiv.appendChild(button);
    } else {
      if (index >= this.buttonDiv.children.length) {
        this.buttonDiv.appendChild(button)
      } else {
        this.buttonDiv.insertBefore(button, this.buttonDiv.children[index])
      }
    }
  }

}